// global.js
document.addEventListener("DOMContentLoaded", function () {
  initializeProductCards();
  window.initializeProductCards = initializeProductCards;
});

function initializeProductCards() {
  // Calculate form heights
  document.querySelectorAll(".product-card").forEach((card) => {
    const form = card.querySelector(".form-container");
    if (form) {
      form.style.display = "block";
      const formHeight = form.offsetHeight;
      form.style.display = "";
      card.style.setProperty("--form-height", `${formHeight}px`);
    }
  });

  // Initialize all product forms with more robust ID handling
  document.querySelectorAll(".product-form").forEach((form) => {
    // Skip if already initialized
    if (form.dataset.initialized === "true") {
      return;
    }

    // Extract product ID from form ID (e.g., "quick-add-123456" -> "123456")
    const formId = form.getAttribute("id") || "";
    const productId =
      formId.replace("quick-add-", "") ||
      form.closest(".product-card")?.id.replace("product-", "") ||
      Date.now().toString();

    const productData = window.productData?.[productId] || {};
    setupProductForm(form, productData);

    // Mark as initialized
    form.dataset.initialized = "true";
  });
}

function setupProductForm(form, productData) {
  const quickAdd = form.querySelector(".quick-add-btn");
  const submitBtn = form.querySelector('[type="submit"]');
  const spinner = form.querySelector(".loading-spinner-quick");
  const buttonText = submitBtn?.querySelector(".button-text");
  const originalText = buttonText?.innerHTML;

  if (!submitBtn) {
    console.warn("No submit button found in form:", form);
    return;
  }

  // Touch event handler
  const handleQuickAdd = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Prevent double submissions
    if (submitBtn.dataset.processing === "true") {
      return;
    }
    submitBtn.dataset.processing = "true";

    // Show loading state
    submitBtn.disabled = true;
    if (buttonText) {
      buttonText.innerHTML = "";
    }
    if (spinner) {
      spinner.style.display = "block";
    }

    try {
      const formData = new FormData(form);
      const variantId = formData.get("id");

      if (!variantId) {
        throw new Error("No variant ID found");
      }

      const response = await fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      const data = await response.json();

      if (
        response.ok &&
        typeof publish !== "undefined" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          action: "add",
          variant: data,
          formData: Object.fromEntries(formData),
          product: productData,
        });
      } else if (!response.ok) {
        throw new Error(data.description || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Quick add error:", error);
      if (
        typeof publish !== "undefined" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "add-to-cart",
        });
      }
    } finally {
      // Reset button state
      submitBtn.disabled = false;
      submitBtn.dataset.processing = "false";
      if (buttonText) {
        buttonText.style.opacity = "1";
        buttonText.innerHTML = originalText;
      }
      if (spinner) {
        spinner.style.display = "none";
      }
    }
  };

  // Remove any existing event listeners by cloning the form
  // This prevents duplicate event listeners
  if (form.dataset.listenersAdded === "true") {
    return;
  }

  // Flag to prevent recursive calls
  let isSubmitting = false;

  // Wrapper to ensure promise is properly handled
  const triggerHandler = async (e) => {
    if (!isSubmitting) {
      isSubmitting = true;
      try {
        await handleQuickAdd(e);
      } finally {
        isSubmitting = false;
      }
    }
  };

  // Add event listeners with preventDefault to handle both mouse and touch
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    triggerHandler(e);
  });

  // Add direct button listener for mobile touch support
  submitBtn.addEventListener("touchend", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!isSubmitting) {
      form.requestSubmit();
    }
  });

  // Mark that listeners have been added
  form.dataset.listenersAdded = "true";
}
